export const selectTotalWater = (state) => state.water.totalWater;
export const selectWaterPortions = (state) => state.water.waterPortions;
export const selectLoading = (state) => state.water.loading;
export const selectError = (state) => state.water.error;
export const selectDateDay = (state) => state.water.dateDay;
export const selectWaterMonth = (state) => state.water.waterMonth;
